import React from 'react';

interface SpinnerProps {
  size?: number;
  color?: string;
}

// Small inline spinner for use inside buttons while an action's AJAX call is
// pending — same pattern as admin/src/components/Spinner.tsx (duplicated
// rather than shared cross-package, since frontend/ and admin/ are separate
// pnpm workspace packages with no shared UI-component package between them).
export function Spinner({ size = 12, color = 'currentColor' }: SpinnerProps) {
  return (
    <span
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        border: `2px solid ${color}`,
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: 'customedge-spin 0.7s linear infinite',
        verticalAlign: 'middle',
      }}
    />
  );
}

// Inject the keyframes once, globally.
if (typeof document !== 'undefined' && !document.getElementById('customedge-spin-keyframes')) {
  const style = document.createElement('style');
  style.id = 'customedge-spin-keyframes';
  style.textContent = '@keyframes customedge-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);
}
